var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { childrenExist, createShorthandFactory, customPropTypes, pxToRem, UIComponent, commonPropTypes, } from '../../lib';
import Icon from '../Icon/Icon';
import Image from '../Image/Image';
import Layout from '../Layout/Layout';
/**
 * A label is used to classify content.
 */
var Label = /** @class */ (function (_super) {
    __extends(Label, _super);
    function Label() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleIconOverrides = function (iconProps) {
            return __assign({}, (iconProps.onClick && { tabIndex: '0' }), (!iconProps.xSpacing && {
                xSpacing: 'none',
            }));
        };
        return _this;
    }
    Label.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, variables = _a.variables, styles = _a.styles;
        var _b = this.props, children = _b.children, content = _b.content, icon = _b.icon, iconPosition = _b.iconPosition, image = _b.image, imagePosition = _b.imagePosition;
        var imageElement = image &&
            Image.create(image, {
                defaultProps: {
                    styles: styles.image,
                    variables: variables.image,
                },
            });
        var iconElement = icon &&
            Icon.create(icon, {
                defaultProps: {
                    styles: styles.icon,
                    variables: variables.icon,
                },
                overrideProps: this.handleIconOverrides,
            });
        var start = null;
        var end = null;
        // Default positioning of the image and icon
        if (image && imagePosition === 'start') {
            start = imageElement;
        }
        if (icon && iconPosition === 'end') {
            end = iconElement;
        }
        // Custom positioning of the icon and image
        if (icon && iconPosition === 'start') {
            if (image && imagePosition === 'start') {
                start = (React.createElement(React.Fragment, null,
                    imageElement,
                    iconElement));
            }
            else {
                start = iconElement;
            }
        }
        if (image && imagePosition === 'end') {
            if (icon && iconPosition === 'end') {
                end = (React.createElement(React.Fragment, null,
                    iconElement,
                    imageElement));
            }
            else {
                end = imageElement;
            }
        }
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }), childrenExist(children) ? (children) : (React.createElement(Layout, { main: content, start: start, end: end, gap: pxToRem(3) }))));
    };
    Label.displayName = 'Label';
    Label.className = 'ui-label';
    Label.propTypes = __assign({}, commonPropTypes.createCommon(), { circular: PropTypes.bool, icon: customPropTypes.itemShorthand, iconPosition: PropTypes.oneOf(['start', 'end']), image: customPropTypes.itemShorthand, imagePosition: PropTypes.oneOf(['start', 'end']), fluid: PropTypes.bool });
    Label.defaultProps = {
        as: 'span',
        imagePosition: 'start',
        iconPosition: 'end',
    };
    return Label;
}(UIComponent));
Label.create = createShorthandFactory(Label, 'content');
export default Label;
